import React, { useContext } from 'react';
import './ResultsV2.scss';
import { layoutContext } from '../../DORAAssessment';
import StatsV2 from '../StatsV2/StatsV2';
import { ArrowRight16, Pdf16 } from '@carbon/icons-react';
import PublicImage from 'src/common/components/PublicImage';
import PopUpV2 from '../PopUpV2/PopUpV2';

interface resultsProps {
  contents: any;
}

const ResultsV2 = (resultsProps: resultsProps) => {
  const { contents } = resultsProps;
  const { selectedItems } = useContext(layoutContext);
  const parentClass = 'dora-assessment-v2__results';
  const selectedItemsArray = Object.values(selectedItems);

  const resultCalc = () => {
    let countYes = 0;
    let countNo = 0;
    let resultObject = {
      title: '',
      subtitle: '',
      imageName: '',
    };
    selectedItemsArray.forEach((item: any) => item === 'yes' && countYes++);
    selectedItemsArray.forEach((item: any) => item === 'no' && countNo++);
    if (countYes >= 5) {
      resultObject = {
        title: 'resultsTitleGreen',
        subtitle: 'resultsSubtitleGreen',
        imageName: 'blue',
      };
    } else if (countYes <= 2 && countNo >= 2) {
      resultObject = {
        title: 'resultsTitleRed',
        subtitle: 'resultsSubtitleRed',
        imageName: 'red',
      };
    } else {
      resultObject = {
        title: 'resultsTitleYellow',
        subtitle: 'resultsSubtitleYellow',
        imageName: 'yellow',
      };
    }
    return resultObject;
  };
  const resultObject = resultCalc();

  const getContryCode = () => {
    const lang =
      document.getElementsByTagName('html')[0].getAttribute('lang') || 'en';

    if (lang === 'en') {
      return 'us-en';
    } else {
      if (lang === 'id-id' || lang === 'ko-kr') {
        return 'us-en';
      } else {
        return lang?.split('-').reverse().join('-');
      }
    }
  };

  const checkFormLink = () => {
    let formLink = '';
    if (window.location.href.includes('products/storage-defender')) {
      selectedItemsArray.map((item: any, i: number) => {
        if (i === 9 && item === 'yes') {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52720';
        } else {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52564';
        }
      });
    } else if (window.location.href.includes('flashsystem/cyber-resilience')) {
      selectedItemsArray.map((item: any, i: number) => {
        if (i === 9 && item === 'yes') {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52720';
        } else {
          formLink = `https://www.ibm.com/flashsystem/pricing/${getContryCode()}/contact/cyberassessment`;
        }
      });
    } else if (window.location.href.includes('storage-data-resilience')) {
      selectedItemsArray.map((item: any, i: number) => {
        if (i === 9 && item === 'yes') {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52720';
        } else {
          formLink = `https://www.ibm.com/flashsystem/pricing/${getContryCode()}/contact/cyberassessment`;
        }
      });
    } else {
      selectedItemsArray.map((item: any, i: number) => {
        if (i === 9 && item === 'yes') {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52720';
        } else {
          formLink = `https://www.ibm.com/flashsystem/pricing/${getContryCode()}/contact/cyberassessment`;
        }
      });
    }
    return formLink;
  };
  const formLink = checkFormLink(); //use this var as the form URL logic
  return (
    <div className={`${parentClass}`}>
      <div className="bx--row">
        <div className={`${parentClass}-title bx--col-lg-8`}>
          <p className={`${parentClass}-title-h2`}>
            {contents[resultObject.title]}
          </p>
          <p className={`${parentClass}-title-h4`}>
            {contents[resultObject.subtitle]}
          </p>
          <div className={`${parentClass}-title-copy`}>
            <p>{contents.resultsCopy}</p>
          </div>
        </div>
        <div className={`${parentClass}-title bx--col-lg-8`}>
          <PublicImage
            imgPath={`images/v2-${resultObject.imageName}-result.png`}
            widgetId="dora-assessment"
            className={`${parentClass}-image-desktop`}
            alt={``}
          />
          <PublicImage
            imgPath={`images/v2-${resultObject.imageName}-result-mobile.png`}
            widgetId="dora-assessment"
            className={`${parentClass}-image-mobile`}
            alt={``}
          />
        </div>
      </div>
      <div className="bx--row">
        <div className={`${parentClass}-copy bx--col-lg-8`}>
          <PublicImage
            imgPath={`images/v2-support-services.svg`}
            widgetId="dora-assessment"
            className={`${parentClass}-copy_image`}
            alt={``}
          />
          <h5>{contents.insightTitle}</h5>
          <p className="pre-link">{contents.insightCopy}</p>
          <a href={formLink} className="link">
            {contents.insightCta} <ArrowRight16 />
          </a>
        </div>
        <div className={`${parentClass}-copy bx--col-lg-8`}>
          <PublicImage
            imgPath={`images/v2-esg-reporting.svg`}
            widgetId="dora-assessment"
            className={`${parentClass}-copy_image`}
            alt={``}
          />
          <h5>{contents.whatDoYouGetTitle}</h5>
          <p className="pre-link">{contents.whatDoYouGetCopy}</p>
          <div className={`${parentClass}-copy_popup`}>
            <PopUpV2 contents={contents} />
          </div>
          <a href="https://www.ibm.com/downloads/cas/AKOGLZDP" className="link">
            {contents.whatDoYouGetCta} <span>(1.3 MB)</span> <Pdf16 />
          </a>
        </div>
      </div>
      <StatsV2 contents={contents} formLink={formLink} />
    </div>
  );
};

export default ResultsV2;
